var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 23.1429C17.9998 20.8696 17.0967 18.6894 15.4893 17.0819C13.8818 15.4745 11.7016 14.5714 9.42836 14.5714C7.15508 14.5714 4.9749 15.4745 3.36745 17.0819C1.75999 18.6894 0.856934 20.8696 0.856934 23.1429H17.9998Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4285 12.0069C12.2688 12.0069 14.5714 9.70433 14.5714 6.864C14.5714 4.02368 12.2688 1.72115 9.4285 1.72115C6.58818 1.72115 4.28564 4.02368 4.28564 6.864C4.28564 9.70433 6.58818 12.0069 9.4285 12.0069Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8571,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.5431cc5338e40866596ca56ea5631670.svg";
export { ForwardRef as ReactComponent };